import React from 'react';
import { BrowserRouter as Router, Route, Redirect, Link } from 'react-router-dom'
import Notifications, {notify} from 'react-notify-toast';
import firebase from 'firebase';

class SignupEmail extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			name: '',
			email: '',
			complete: false
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

	}

	handleInputChange(event) {
		const target = event.target;
		// const value = target.type === 'checkbox' ? target.checked : target.value;
		const value = target.value;
		const name = target.name;
		this.setState({
			[name]: value
		});
	}

	handleSubmit(event) {
		event.preventDefault();
		// console.log('handleSubmit', this.state);
		firebase.auth().signInAnonymously()
		.then(response => {
			firebase.auth().currentUser.updateProfile({
				displayName: this.state.name
			}).then((response) => {
				// console.log('user name updated', response)
				firebase.auth().currentUser.updateEmail(this.state.email).then(() => {
					// console.log('user email updated', response);
					this.setState({
						complete: true
					});
				}).catch((error) => {
					notify.show('That email address is already in use', 'error');
					console.warn('error setting user email', error);
				});
			}).catch((error) => {
				console.warn('error setting user name', error);
			});
		})
		.catch(error => {
			console.warn('error siging in', error);
		})
	}

	render() {

		if (this.state.complete) {
			return <Redirect to='/games/'/>;
		}

		return <section className="signup">

		<header>
		<h1>The Village</h1>
		</header>

		<main>

			<div className="actions ridged">

				<form onSubmit={this.handleSubmit}>
					<label>Full Name</label>
					<input name="name" type="text" placeholder="Full Name" autofocus value={this.state.name} onChange={this.handleInputChange}/>

					<label>Email Address</label>
					<input name="email" type="email" placeholder="Email Address" value={this.state.email} onChange={this.handleInputChange}/>

					{/* TODO On Submit show loader */}
					<button type="submit" className="button -primary -huge">Join the Game</button>

					<Link to={`/`}>
						Cancel
					</Link>
				</form>

			</div>
		</main>

		</section>;
	}
}

export default SignupEmail



// WEBPACK FOOTER //
// ./src/components/signup.email.js